import tableSportRoomManualProviders from './tableSportRoomManualProviders';

export default {
  title: 'Manual V.T. Providers',
  attributeName: 'appProvider',
  getURL: 'appId/appProvider',
  createURL: 'appId/appProvider',
  updateURL: 'appId/appProvider',
  removeURL: 'appId/appProvider',
  sessionParams: ['appId'],
  noArea: true,
  removeNameField:'name',
  removeText:'You are about to remove the Manual V.T. Providers with name ##name##.',
  tableConfig: tableSportRoomManualProviders,
  autoUpdate: true,
};
